import { Organismo } from "dtos/organismo";
import { OrganismosTableRowActions } from "./OrganismosTableRowActions";
import { GenericTable } from "components/GenericTable";

export function OrganismosTable({ elementos }: {
  elementos: Organismo[];
}) {
  return (
<GenericTable
  items={elementos}
  columns={[
    {
      label: "Nombre",
      render: (item) =>
      {
        return item.nombre;
      },
    },
    {
      label: "Abreviatura",
      render: (item) =>
      {
        return item.abreviatura;
      },
    },
    {
      label: "Descripcion",
      render: (item) =>
      {
        return item.descripcion ?? "";
      },
    },
    {
      width: "1%",
      label: "Acciones",
      render: (item) =>
      {
        return <OrganismosTableRowActions organismo={item}/>;
      },
    },
  ]}
  emptyMessage={
  <>
    <b>No hay organismos para visualizar.</b> Para poder
    visualizar organismos debes <br /> seleccionar el botón
    agregar «Nuevo organismo».
  </>}
/>
  )
}
